/**
 * Cancels the browser's native drag of images and links app-wide.
 *
 * Both <img> and <a> are drag sources by default: the browser spawns a ghost
 * preview and a drop payload, which reads as a bug inside an app UI.
 *
 * `img, a { -webkit-user-drag: none }` in styles.css already covers
 * Blink/WebKit, but `user-drag` was never standardized and Firefox ignores it,
 * so the ghost still appears there. This guard closes that gap without touching
 * every <img> and <a> in the app — and keeps future ones covered by default.
 *
 * Dragging stays possible where the app asks for it: anything marked
 * `draggable="true"`, or nested inside such an element, is left alone. Dragging
 * a plain text selection is untouched, since it starts on neither an image nor
 * a link.
 */
export function cancelNativeDrag(event: DragEvent) {
  const target = event.target

  if (!(target instanceof Element)) return
  if (target.closest('[draggable="true"]')) return
  if (!target.closest('img, a')) return

  event.preventDefault()
}

if (typeof window !== 'undefined') {
  document.addEventListener('dragstart', cancelNativeDrag)
}
